import * as React from "react";

function SvgRounded3Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M1610.5 24.1s-128.2 82.6-138.2 89.2c-17.1 11.3-37.2 15.5-87 18.1-49.7 2.6-753.6 40.7-783.9 42.3-30.3 1.5-81.1 1.3-121.1-8.2S-9.5 50-9.5 50v158.9h1620V24.1z" /></svg>;
}

export default SvgRounded3Inverted;